import { render, staticRenderFns } from "./OriginsCard.vue?vue&type=template&id=7abe898f&"
import script from "./OriginsCard.vue?vue&type=script&lang=js&"
export * from "./OriginsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports